import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {useTranslation} from "react-i18next";
import {acrossAllModulesPublicTrackingSearch} from "../../api/ShipmentEndpoint";
import {useSnackbar} from "notistack";
import Grid from "@material-ui/core/Grid";
import Loader from "../core/Loader";
import Container from "@material-ui/core/Container";
import withWidth, {WithWidthProps} from "@material-ui/core/withWidth";
import PublicTrackingSearch from "./PublicTrackingSearch";
import {PublicTrackingInfoCard} from "./PublicTrackingInfoComponents";
import {getParcelPublicByTrackingId} from '../../api/ParcelEndpoint';
import {ExternalPublicTrackingDTO} from "../../constants/ParcelContants";
import {PublicTrackingInterface, ShipmentsNotFound, SingleShipmentHit} from "./PublicTrackingSearchResultComponents";
import {AppBar, Button, Card, CardActionArea, CardContent, Toolbar, Typography} from "@material-ui/core";
import {ArrowBack} from '@material-ui/icons';
import ParcelResultsComponents from './ParcelResultsComponents';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flex: 1,
            justifyContent: "center"
        },
        grid: {
            "& .MuiGrid-item": {
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column"
            }
        },
        notFound: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            "& .MuiSvgIcon-root": {
                height: 100,
                width: 100
            }
        },
        modality: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            "& img": {
                height: 40
            }
        },

    }),
);
export const VCPPublicTrackingSearchResultComponents: React.FC<{ search: string } & WithWidthProps> = ({
                                                                                                           search,
                                                                                                           width
                                                                                                       }) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const {enqueueSnackbar} = useSnackbar();

    const [publicTracking, setPublicTracking] = React.useState <PublicTrackingInterface[] | undefined>(undefined);
    const [parcel, setParcel] = React.useState<ExternalPublicTrackingDTO | undefined | null>(undefined);


    React.useEffect(() => {
        acrossAllModulesPublicTrackingSearch(search).then(response => {
            setPublicTracking(response);
        })


        getParcelPublicByTrackingId(search).then(({data}) => {

            setParcel(data ? data : null);
        })


    }, [search, enqueueSnackbar, t]);


    if (!
        publicTracking || parcel === undefined
    ) {
        return <Loader/>
    }


    return (<div className={classes.root}>


            <Container>

                <Grid container
                      spacing={2}>
                    <Grid item xs={12}>
                        <PublicTrackingSearch/>
                    </Grid>
                    {(publicTracking.length === 1 && parcel === null) &&
                    <SingleShipmentHit publicTracking={publicTracking[0]} width={width}/>}

                    {(publicTracking.length === 0 && !!parcel) &&
                    <ParcelResultsComponents parcel={parcel}/>}

                    {(publicTracking.length > 1 || (publicTracking.length > 0 && !!parcel)) &&
                    <Grid item xs={12}><MultipleDataGrid shipments={publicTracking} parcel={parcel}
                                                         width={width}/></Grid>}


                    {(publicTracking.length === 0 && parcel === null) &&
                    <ShipmentsNotFound/>}

                </Grid>
                <Grid item xs={12}>
                    <PublicTrackingInfoCard/>
                </Grid>
            </Container>

        </div>
    );
}

export const MultipleDataGrid: React.FC<{ shipments: Array<PublicTrackingInterface>, parcel: ExternalPublicTrackingDTO | undefined | null } & WithWidthProps> = ({
                                                                                                                                                                     shipments,
                                                                                                                                                                     parcel,
                                                                                                                                                                     width
                                                                                                                                                                 }) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const [selected, setSelected] = React.useState<PublicTrackingInterface | ExternalPublicTrackingDTO | undefined>(undefined);

    if (selected) {
        return <WrapperDetailsView selected={selected} back={() => setSelected(undefined)} width={width}/>
    }

    return (<Grid container
                  spacing={2}>

        <Grid item xs={6}>
            <AppBar position="relative">
                <Toolbar variant="dense">
                    <Typography gutterBottom variant="h6" component="h2">
                        {t("public-tracking.found.shipments")}
                    </Typography>
                </Toolbar>
            </AppBar>

            {shipments.map((shipment, index) => (
                <Card key={index} style={{marginBottom: 10}}>
                    <CardActionArea onClick={() => setSelected(shipment)}>
                        <CardContent>
                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <Typography gutterBottom variant="h6" component="h2">
                                    {`${t("shipment.spotId")}: ${shipment?.general.spotID}`}
                                </Typography>
                                <div className={classes.modality}>
                                    <img
                                        src={`/assets/icons/modalities/${shipment.general?.modality.toLowerCase()}.png`}
                                        alt={shipment.general?.modality}/>
                                    <Typography
                                        variant="caption">{t("core.modality." + shipment.general?.modality)}</Typography>
                                </div>
                            </div>
                            <Typography variant="body2" color="textSecondary" component="p">
                                {t("shipment.shipper-country") + ": " + shipment.general?.shipper}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                {t("shipment.consignee-country") + ": " + shipment.general?.consignee}
                            </Typography>

                        </CardContent>
                    </CardActionArea>
                </Card>
            ))}

        </Grid>

        {parcel && <Grid item xs={6}>
            <AppBar position="relative">
                <Toolbar variant="dense">
                    <Typography gutterBottom variant="h6" component="h2">
                        {t("public-tracking.found.parcel")}
                    </Typography>
                </Toolbar>
            </AppBar>

            <Card>
                <CardActionArea onClick={() => setSelected(parcel)}>
                    <CardContent>
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <Typography gutterBottom variant="h6" component="h2">
                                {`${t("parcel.trackingID")}: ${parcel.trackingID}`}
                            </Typography>
                            <div className={classes.modality}>
                                <img
                                    src={`/assets/icons/parcel.png`}
                                    alt={"parcel"}/>
                            </div>
                        </div>
                        {parcel.packages?.map((pckg, index) => {
                            return (<Typography key={index} variant="body2" color="textSecondary" component="p">
                                {t("parcel.licensePlate") + ": " + pckg.licensePlate}
                            </Typography>)
                        })}


                    </CardContent>
                </CardActionArea>
            </Card>

        </Grid>}
    </Grid>)
}

const WrapperDetailsView: React.FC<{ selected: PublicTrackingInterface | ExternalPublicTrackingDTO, back: () => void } & WithWidthProps> = ({
                                                                                                                                                selected,
                                                                                                                                                back,
                                                                                                                                                width
                                                                                                                                            }) => {
    function isShipment(arg: any): arg is PublicTrackingInterface {
        return arg.general !== undefined;
    }

    function isParcel(arg: any): arg is ExternalPublicTrackingDTO {
        return arg.trackingID !== undefined;
    }

    return (<>
        <Toolbar>
            <Button
                onClick={back}
                color="default"
                size="small"
                startIcon={<ArrowBack/>}
            >
                Back to search results
            </Button>
        </Toolbar>
        {isShipment(selected) && <SingleShipmentHit publicTracking={selected} width={width}/>}
        {isParcel(selected) && <ParcelResultsComponents parcel={selected}/>}
    </>)

}
export default withWidth()(VCPPublicTrackingSearchResultComponents);
